export const LAST_CREATED_PHOTOS_TEXT = 'LES DERNIÈRES PHOTOS CRÉEES';
export const SEARCH_BAR_PLACEHOLDER = 'Rechercher des images One Photos';
